import Vue from 'vue';
import 'amfe-flexible';
import App from './App';
import axios from "./axios";
import VueAxios from "vue-axios";
import { router } from './router';
import Back from '@/common/plusready.js'

import "./styles/common.css";
Vue.use(VueAxios, axios);


new Vue({
    router,
    Back,
    el: '#app',
    render: h => h(App)
});
